import { classNames } from "@gettactic/helpers/src/css/classNames";
import { InteractiveZonesInfo } from "@gettactic/helpers/src/map/types";
import React from "react";
import { InteractiveActiveSpot } from "./InteractiveActiveSpot";
import { cn } from "@gettactic/helpers";

export interface MapEditSelectedZonesProps {
  selectedZones: string[];
  zonesInfo: InteractiveZonesInfo;
  className?: string;
}
export const MapEditSelectedZones: React.FC<MapEditSelectedZonesProps> = (
  props
) => {
  const { selectedZones, zonesInfo, className } = props;
  const { mapInfo } = zonesInfo;

  const items = React.useMemo(() => {
    return selectedZones.map((zoneId) => {
      return zonesInfo.zones.find((zone) => {
        if (zone.id === zoneId) {
          return zone;
        }

        return null;
      });
    });
  }, [selectedZones]);

  if (!mapInfo) {
    return null;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...mapInfo.attrs}
      className={cn("interactive-zone-svg pointer-events-none", className)}
    >
      {items
        .filter((item) => !!item)
        .map((item, index) => {
          return (
            <InteractiveActiveSpot
              key={item!.id}
              zone={item!}
              title={String(items.length - index)}
              className={"map-edit-element-selected"}
            />
          );
        })}
    </svg>
  );
};
